import { UnleashClient } from '@unleash/proxy-client-vue'

import {
  FLAG_CHANNELS,
  FLAG_CONTENT_DETAIL_MODAL,
  FLAG_EMAIL_QUOTA,
  FLAG_GA_ORDER_COLLECTOR,
  FLAG_PARTICIPANT_PAYMENT_SPLIT,
  FLAG_SEGMENTS,
} from '@/lib/constants/flags'
import { config } from '@/lib/helpers/config.helpers'
import { isDemoMode } from '@/lib/helpers/demo.helpers'

export const demoEnabledFlags = [
  FLAG_EMAIL_QUOTA,
  FLAG_GA_ORDER_COLLECTOR,
  FLAG_CHANNELS,
  FLAG_CONTENT_DETAIL_MODAL,
  FLAG_SEGMENTS,
  FLAG_PARTICIPANT_PAYMENT_SPLIT,
]

const demoBootstrap = demoEnabledFlags.map((name) => ({
  name,
  enabled: true,
  variant: { name: 'disabled', enabled: false },
  impressionData: false,
}))

const unleashConfig = {
  url: config.unleash.proxyUrl,
  clientKey: config.unleash.clientKey,
  refreshInterval: 120,
  appName: 'advertiser-app',
  disableMetrics: true,
  environment: config.environment,
  ...(isDemoMode && { bootstrap: demoBootstrap, bootstrapOverride: true }),
}

export const unleashClient = new UnleashClient(unleashConfig)
